// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkusFilterDropdown_filter-dropdown__EuxoV {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.SkusFilterDropdown_filter-dropdown__header__l\\+rvD {
  color: var(--gray-extra-dark);
  font-size: var(--text-sm);
  font-weight: 500;
}

.SkusFilterDropdown_filter-dropdown__btn__qoBgt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  border: 1px solid var(--black-ten-opacity);
  border-radius: 0.8rem;
  padding: 1.5rem;
  color: #000;
  font-size: var(--text-sm);
  font-weight: 500;
  width: 15rem;
}

.SkusFilterDropdown_filter-dropdown__btn__qoBgt:disabled {
  border: none;
}

.SkusFilterDropdown_filter-dropdown__text__QrtY3 {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SkusFilterDropdown_filter-dropdown__icon__wmLN- {
  width: 1rem;
  height: 1rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/Skus/SkusFilters/SkusFilterDropdown/SkusFilterDropdown.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,qBAAqB;EACrB,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".filter-dropdown {\n  display: flex;\n  flex-direction: column;\n  gap: 1.2rem;\n}\n\n.filter-dropdown__header {\n  color: var(--gray-extra-dark);\n  font-size: var(--text-sm);\n  font-weight: 500;\n}\n\n.filter-dropdown__btn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n  border: 1px solid var(--black-ten-opacity);\n  border-radius: 0.8rem;\n  padding: 1.5rem;\n  color: #000;\n  font-size: var(--text-sm);\n  font-weight: 500;\n  width: 15rem;\n}\n\n.filter-dropdown__btn:disabled {\n  border: none;\n}\n\n.filter-dropdown__text {\n  max-width: 90%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.filter-dropdown__icon {\n  width: 1rem;\n  height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filter-dropdown": `SkusFilterDropdown_filter-dropdown__EuxoV`,
	"filter-dropdown__header": `SkusFilterDropdown_filter-dropdown__header__l+rvD`,
	"filter-dropdown__btn": `SkusFilterDropdown_filter-dropdown__btn__qoBgt`,
	"filter-dropdown__text": `SkusFilterDropdown_filter-dropdown__text__QrtY3`,
	"filter-dropdown__icon": `SkusFilterDropdown_filter-dropdown__icon__wmLN-`
};
export default ___CSS_LOADER_EXPORT___;
